import {Injectable} from "@angular/core";
import {ToolsBoxService} from "./tools.service";
import {User} from "../Models/user.model";
import {BalanceHolder} from "../Models/Holders/balanceholder.model";
import {CalendarEventHolder} from "../Models/Holders/calendareventholder.model";
import {BillingHolder} from "../Models/Holders/billingholder.model";
import {PlanningItem} from "../Models/planningitem.model";
import {CallApi, HTTP_COMMAND} from "./callApi";
import {SocialEventRequest} from "../Models/Holders/SocialEventRequest.model";
import {TechRadarDataHolder} from "../Models/Holders/techRadarDataHolder.model";
import {map} from "rxjs/operators";
import {Observable} from "rxjs";
import {WorkingDayConfigHolder} from "../Models/Holders/workingDaysConfigHolder";
import {BalanceReportItem} from "../Models/Holders/balanceReportHolder.model";

@Injectable()
export class UserService {
  constructor(private callAPI: CallApi, private toolsBox: ToolsBoxService) {
  }

  /**
   * USER ADMINISTRATION
   */
    //Used for Directory
  getUserList = (): Observable<User[]> => {
    return this.callAPI.call(HTTP_COMMAND.GET, "/users/");
  };
  //Used for Settings
  getUserInformation = (user: User): Observable<User> => {
    return this.callAPI.call(HTTP_COMMAND.GET, "/users/", user.id);
  };
  //Used for Settings
  updateUserInformation = (
    newUser: User,
    password: string
  ): Observable<boolean> => {
    if (password) {
      newUser.userSalt = this.toolsBox.generateRandomString(15);
      newUser.userPassword =
        "" + this.toolsBox.convertPassword(password, newUser.userSalt);
    }
    return this.callAPI
      .call(
        HTTP_COMMAND.PUT,
        "/users/" + this.toolsBox.getStoredUserId(),
        newUser
      )
      .pipe(map(() => true));
  };
  //Used when changing password
  updateUserPwd = (
    userlogin: string,
    password: string
  ): Observable<boolean> => {
    const newSalt = this.toolsBox.generateRandomString(15);
    const paramUser =
      "{" +
      '"id":' +
      this.toolsBox.getStoredUserId() +
      ',"userLogin":"' +
      userlogin +
      '","userPassword":"' +
      this.toolsBox.convertPassword(password, newSalt) +
      '","userSalt":"' +
      newSalt +
      '"}';
    return this.callAPI
      .call(
        HTTP_COMMAND.PUT,
        "/users/" + this.toolsBox.getStoredUserId() + "/password/",
        paramUser
      )
      .pipe(map(() => true));
  };
  //Used for Dashboard
  getUserBalance = (
    userId: number,
    selectedYear: number
  ): Observable<BalanceHolder> => {
    let serviceURi = "/balances/" + selectedYear;
    if (userId != null) {
      serviceURi = "/admin/balances/user/" + userId + "/year/" + selectedYear;
    }
    return this.callAPI.call(HTTP_COMMAND.GET, serviceURi);
  };
  /**
   * SOCIAL EVENT ADMINISTRATION
   */
  handleEventInvitation = (
    event: CalendarEventHolder
  ): Observable<PlanningItem[]> => {
    return this.callAPI.call(
      HTTP_COMMAND.PUT,
      "/social-events/" + event.eventId,
      event
    );
  };
  /**
   * TIME SHEETS
   */
  getUserBilledHours = (
    user: User,
    selectedYear: number
  ): Observable<BillingHolder> => {
    let serviceURi = "/timesheets/" + selectedYear;
    if (user != null) {
      serviceURi =
        "/admin/timesheets/user/" + user.id + "/year/" + selectedYear;
    }
    return this.callAPI
      .call(HTTP_COMMAND.GET, serviceURi)
      .pipe(map((data) => new BillingHolder(data)));
  };

  getBilledHoursForYear = (selectedYear: number): Observable<BillingHolder[]> => {
    let serviceURi = "/admin/timesheets/year/" + selectedYear;
    return this.callAPI
      .call(HTTP_COMMAND.GET, serviceURi)
      .pipe(map((data) => data.map((element: any) => new BillingHolder(element))));
  };

  getTimesheetExport = (year: number, date: string): Observable<void> => {
    const month = date.substring(5);
    const serviceURi = "/timesheets/export/" + year + "/" + month;

    return this.callAPI.call(HTTP_COMMAND.GET, serviceURi, null, "blob").pipe(
      map((data) => {
        const a = document.createElement("a");
        document.body.appendChild(a);
        const blob: any = new Blob([data], {type: "octet/stream"});
        const url = window.URL.createObjectURL(blob);
        a.href = url;
        a.download = "TS-" + date + ".xlsx";
        a.click();
        window.URL.revokeObjectURL(url);
      })
    );
  };

  /**
   * EVENT ADMINISTRATION
   */

    //Used for Time Management
  sendUserEvent = (holder: CalendarEventHolder): Observable<boolean> => {
    if (holder.eventId > 0) {
      return this.callAPI
        .call(HTTP_COMMAND.PUT, "/events/" + holder.eventId, holder)
        .pipe(map(() => true));
    } else {
      return this.callAPI
        .call(HTTP_COMMAND.POST, "/events/", holder)
        .pipe(map(() => true));
    }
  };

  //Used for Time Management and Overview
  getUserEvent = (user: User): Observable<CalendarEventHolder[]> => {
    let serviceURi = "/events/";
    if (user != null) {
      serviceURi = "/admin/events/user/" + user.id;
    }
    return this.callAPI.call(HTTP_COMMAND.GET, serviceURi);
  };

  //Used for Time Management and Overview
  getUserPartTime = (user: User, year: number): Observable<WorkingDayConfigHolder[]> => {
    let serviceURi = `/users/${year}/working-days-config`;
    if (user != null) {
      serviceURi = `/admin/user/${user.id}/${year}/working-days-config`;
    }
    return this.callAPI.call(HTTP_COMMAND.GET, serviceURi);
  };

  /**
   * TECH RADAR
   */
  getTechRadarData = (user: User): Observable<any> => {
    let serviceURi = "/techradar/";
    if (user != null) {
      serviceURi = "/coordinator/techradar/" + user.id;
    }
    return this.callAPI
      .call(HTTP_COMMAND.GET, serviceURi)
      .pipe(map((data) => new TechRadarDataHolder(data)));
  };
  updateSkills = (data: TechRadarDataHolder): Observable<boolean> => {
    const serviceURi = "/techradar/";
    return this.callAPI.call(HTTP_COMMAND.PUT, serviceURi, data);
  };
  getTechRadaStat = (): Observable<any> => {
    const serviceURi = "/coordinator/stats/";
    return this.callAPI.call(HTTP_COMMAND.GET, serviceURi);
  };
  /**
   * ADMIN PART
   */
    //Used for Time Management
  getPendingRequest = (): Observable<CalendarEventHolder[]> => {
    return this.callAPI.call(HTTP_COMMAND.GET, "/admin/requests");
  };
  //Used for Time Management / ADMIN
  manageRequest = (holder: CalendarEventHolder): Observable<boolean> => {
    return this.callAPI
      .call(HTTP_COMMAND.PUT, "/admin/requests/" + holder.eventId, holder)
      .pipe(map(() => true));
  };
  //Used for User Management
  getItzList = (): Observable<User[]> => {
    return this.callAPI.call(HTTP_COMMAND.GET, "/admin/itz/");
  };
  //Used for User Management detail
  getItzById = (userId: number): Observable<User> => {
    return this.callAPI.call(HTTP_COMMAND.GET, "/admin/itz/" + userId);
  };
  //Used for Admin Management
  createITz = (newUser: User): Observable<string> => {
    return this.callAPI
      .call(HTTP_COMMAND.POST, "/admin/itz/", newUser)
      .pipe(map(() => "This account has been created"));

  };
  //Used for Admin Management
  updateITz = (newUser: User): Observable<User> => {
    return this.callAPI
      .call(HTTP_COMMAND.PUT, "/admin/itz/" + newUser.id, newUser)
      .pipe(map((response) => response as User));
  };
  //create Social Events
  createEvents = (request: SocialEventRequest): Observable<boolean> => {
    return this.callAPI
      .call(HTTP_COMMAND.POST, "/admin/social-events/", request)
      .pipe(map(() => true));
  };
  //Used for reseting user password
  resetUserPassword = (user: User, password: string): Observable<number> => {
    return (
      this.callAPI
        .call(
          HTTP_COMMAND.PUT,
          "/admin/itz/" + user.id + "/password/",
          '{"userLogin":"' +
          user.userLogin +
          '",' +
          '"id":"' +
          user.id +
          '", ' +
          '"userPassword":"' +
          password +
          '", ' +
          '"userPasswordTmp":"' +
          user.userPasswordTmp +
          '"' +
          "}"
        )
        //Convert the Observable<Response> to a Json Object
        .pipe(map(() => 0))
    );
  };
  getSocialEventPlanning = (): Observable<PlanningItem[]> => {
    let serviceURi = "/social-events/";
    if (this.toolsBox.isEventManager()) {
      serviceURi = "/coordinator/planning/";
    }
    return this.callAPI.call(HTTP_COMMAND.GET, serviceURi);
  };

  getBalanceReport = (year: number): Observable<BalanceReportItem[]> => {
    return this.callAPI.call(HTTP_COMMAND.GET, '/admin/balance/year/' + year);
  };
}
